export default __webpack_public_path__ + "static/media/GreycliffCF-Bold.24f2be30.woff";